import { useQuery, useQueryClient } from "@tanstack/react-query";
import { sendAjaxRequest } from "@/ts/api/comunicacion";
import { BaseModal, ModalCloseCross } from "@/components/modals/BaseModal";
import type { Respuesta, Usuario } from "@/ts/typings/clases";
import { TablaMaquinasUsuario } from "./TablaMaquinasUsuario";
import { useState } from "react";
import { notificacionTipo } from "@/components/Alerts";
import type { RowSelectionState } from "@tanstack/react-table";

interface ModalMaquinasProps {
	readonly shown: boolean;
	readonly close: () => void;
	readonly usuario: Usuario | null;
}
export function ModalMaquinas(props: ModalMaquinasProps) {
	const [maquinasSeleccionadas, setMaquinasSeleccionadas] = useState<RowSelectionState>({});
	const queryClient = useQueryClient();

	const onGuardar = () => {
		if (!props.usuario) return;

		const newMaquinas = Object.entries(maquinasSeleccionadas).map(([id]) => id);

		void sendAjaxRequest<Respuesta>("POST", "/api/v1/setMaquinaria", {
			"newMaquinas": newMaquinas,
			"idUsuario": props.usuario.id,
		}).then((res) => {
			if (res.tipo != "success") {
				notificacionTipo("error", res.message ?? "Error al guardar las máquinas");
				void queryClient.invalidateQueries({ queryKey: ["getMaquinaria", props.usuario?.id] });
				return;
			}

			notificacionTipo("success", res.message ?? "Máquinas guardadas con éxito");
			props.close();
			void queryClient.invalidateQueries({ queryKey: ["getMaquinaria", props.usuario?.id] });
		});
	};

	return (
		<BaseModal show={props.shown} close={props.close} minWidth="30%">
			<div className="modal-header">
				<h4 className="modal-title">Maquinas de {props.usuario?.nombre ?? ""} {props.usuario?.apellido ?? ""}</h4>
				<ModalCloseCross onClick={props.close} />
			</div>
			<div className="modal-body">
				{props.usuario ? (
					<TablaMaquinasUsuario
						idRepresentante={props.usuario.id}
						selectedMaquinas={maquinasSeleccionadas}
						setSelectedMaquinas={setMaquinasSeleccionadas}
					/>
				) : null}
			</div>
			<div className="modal-footer">
				<button type="button" className="btnSecondary" onClick={props.close}>Cancelar</button>
				<button type="button" className="btnPrimary" onClick={onGuardar}>Guardar</button>
			</div>
		</BaseModal>
	);
}

export function useMaquinasUsuario(idRepresentante: string) {
	return useQuery<Maquina[]>({
		queryKey: ["getMaquinaria", idRepresentante],
		queryFn: () => {
			return sendAjaxRequest<Maquina[]>("GET", "/api/v1/getMaquinaria", { representante_id: idRepresentante });
		},
	});
}
export interface Maquina {
	xoperacion_id: string,
	xdescripcion: string,
	operariosCount: string,
	check: boolean,
}
